import { createContext, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null = checking, false = logged out

  useEffect(() => {
    const check = async () => {
      if (!localStorage.getItem(TOKEN_KEY)) {
        setAdmin(false);
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        setAdmin(data);
      } catch {
        localStorage.removeItem(TOKEN_KEY);
        setAdmin(false);
      }
    };
    check();
  }, []);

  const login = async (userId, password) => {
    const { data } = await api.post("/auth/login", { user_id: userId, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setAdmin({ user_id: data.user_id });
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    localStorage.removeItem(TOKEN_KEY);
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
